import { getData } from 'country-list';

const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
const nameOverrides = { HK: 'Hong Kong' };

export const countries = getData()
  .map(({ code, name }) => ({ code, name: nameOverrides[code] || displayNames.of(code) || name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const getCountry = (code) =>
  countries.find((country) => country.code === String(code || '').toUpperCase());
